import { TextButtonPriority, TextButton, } from '../../TextButton';
export class AvatarGroupTextButton extends TextButton {
}
AvatarGroupTextButton.defaultProps = {
    priority: TextButtonPriority.secondary,
};
//# sourceMappingURL=AvatarGroupTextButton.js.map